import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const PowerKpiIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorIcon;

  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5363 8.82153L7.66135 17.259C7.57789 17.3481 7.46774 17.4076 7.3475 17.4286C7.22726 17.4495 7.10347 17.4308 6.9948 17.3752C6.88613 17.3197 6.79849 17.2303 6.74508 17.1205C6.69168 17.0108 6.67543 16.8866 6.69877 16.7668L7.72955 11.6108L3.67744 10.0893C3.59042 10.0567 3.51281 10.0031 3.45156 9.93324C3.3903 9.86338 3.34731 9.77943 3.32642 9.6889C3.30552 9.59836 3.30738 9.50406 3.33183 9.41442C3.35627 9.32478 3.40254 9.24259 3.4665 9.1752L11.3415 0.7377C11.425 0.648639 11.5351 0.589138 11.6553 0.568174C11.7756 0.547211 11.8994 0.565924 12.008 0.621488C12.1167 0.677053 12.2044 0.766455 12.2578 0.876203C12.3112 0.985951 12.3274 1.11009 12.3041 1.22989L11.2705 6.39153L15.3226 7.91098C15.409 7.94375 15.486 7.9973 15.5467 8.06688C15.6075 8.13647 15.6502 8.21995 15.6711 8.30996C15.6919 8.39997 15.6903 8.49372 15.6663 8.58295C15.6423 8.67217 15.5967 8.75411 15.5335 8.82153H15.5363Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default PowerKpiIcon;
